import "./styles.css";

const navItems = [
  ["O Escritório", "/escritorio/"],
  ["Áreas de Atuação", "/areas-de-atuacao/"],
  ["Advogados", "/advogados/"],
  ["Clientes", "/clientes/"],
  ["Notícias", "/noticias/"],
  ["Contato", "/contato/"],
];

const practiceAreas = [
  ["Improbidade Administrativa", "Representação em procedimentos preparatórios, inquéritos civis e ações civis públicas."],
  ["Tribunais de Contas", "Atuação em prestação e tomada de contas, representações e temas de controle externo."],
  ["Licitações e Contratos", "Suporte desde o edital até a execução contratual e a entrega definitiva."],
  ["Contencioso Administrativo", "Consultoria e representação perante órgãos e entidades da Administração Pública."],
  ["Lei Anticorrupção e Compliance", "Programas de integridade, prevenção de riscos e adequação regulatória."],
  ["Direito Eleitoral", "Atuação estratégica em campanhas, partidos e demandas do ambiente eleitoral."],
];

const officePillars = [
  ["Segurança jurídica", "Atuação responsável e estruturada para preservar decisões, contratos e relações institucionais."],
  ["Atendimento sob medida", "Soluções jurídicas ajustadas à realidade, ao setor e à complexidade de cada cliente."],
  ["Presença técnica", "Experiência em ambientes administrativos, regulatórios, eleitorais e empresariais."],
];

const contactAddress = "Avenida Miguel Sutil - 8.695 - 2º andar - Edifício The Centrus Tower - Duque de Caxias - Cuiabá/MT - CEP: 78043-305.";
const mapUrl = "https://maps.google.com/maps?q=edificio%20centrus%20tower%2C%20cuiaba&t=m&z=18&output=embed&iwloc=near";

const team = [
  {
    initials: "MM",
    name: "Mauricio Magalhães Faria Júnior",
    registry: "OAB/MT 9.839",
    description: "Direito público, tributário e administração pública.",
    bio: [
      "Bacharel em Direito pela Universidade de Cuiabá, com aprovação no IV Exame de Ordem Unificado.",
      "Especialista em Direito Processual Civil e mestre em Direito, Desenvolvimento e Justiça pelo IDP.",
      "Atuação voltada a demandas administrativas, empresariais e institucionais complexas.",
    ],
  },
  {
    initials: "MN",
    name: "Mauricio Magalhães Faria Neto",
    registry: "OAB/MT 15.436",
    description: "Contencioso administrativo, compliance e integridade.",
    bio: [
      "Bacharel em Direito pela Universidade de Cuiabá e aprovado no Exame de Ordem em 2005.",
      "MPA pela Fundação Getúlio Vargas em Direito do Estado e Administração Pública com ênfase em controle externo.",
      "Especialista em Direito Tributário e Finanças Públicas pelo IDP, com experiência em controle, integridade e Administração Pública.",
    ],
  },
  {
    initials: "RC",
    name: "Rayssa Toledo Balster de Castilho",
    registry: "OAB/MT 30.320",
    description: "Direito administrativo, empresarial e cível.",
    bio: [
      "Graduada em Direito pela Universidade de Várzea Grande - UNIVAG.",
      "Pós-graduanda em Direito Administrativo pelo IDP.",
      "Atuante em direito administrativo, tributário e cível.",
    ],
  },
  {
    initials: "AA",
    name: "Andrey Arantes Abdala Azevedo",
    registry: "OAB/MT 29.524",
    description: "Direito administrativo, tributário e cível.",
    bio: [
      "Graduada em Direito pela Universidade de Cuiabá - UNIC.",
      "Pós-graduada em Direito Processual Civil e Métodos Alternativos de Solução de Conflitos pela PUC Minas.",
      "Atuação em direito administrativo, empresarial e cível.",
    ],
  },
  {
    initials: "GL",
    name: "Gustavo Gomes Lourenço",
    registry: "OAB/MT 31.731",
    description: "Direito administrativo, empresarial e cível.",
    bio: [
      "Graduado em Direito pela Universidade de Várzea Grande - UNIVAG.",
      "Advogado inscrito nos quadros da OAB/MT desde outubro de 2022.",
      "Atuação em direito administrativo, empresarial e cível.",
    ],
  },
];

const clients = [
  ["Santa Cruz Engenharia", "/assets/logo-santa.jpg"],
  ["Métrica Construções", "/assets/logo-metrica.jpg"],
  ["Conenge", "/assets/logo-conenge.jpg"],
  ["Fórmula Distribuidora", "/assets/logo-formula.jpg"],
  ["Planservi Engenharia", "/assets/logo-planservi.jpg"],
];

const posts = [
  {
    title: "Termo Anticorrupção e postura pró-ativa das empresas",
    description: "Leitura sobre integridade empresarial, ambiente regulatório e respostas institucionais exigidas das organizações.",
    image: "/assets/mauricio-artigo.jpeg",
    href: "/2023/03/02/termo-anticorrupcao-e-postura-pro-ativa-das-empresas/",
    large: true,
  },
  {
    title: "O marco regulatório da integridade na Administração Pública em Mato Grosso",
    description: "Panorama sobre integridade pública, regulação e impactos práticos na administração.",
    image: "/assets/adv-mauricio.jpg",
    href: "/2023/03/02/o-marco-regulatorio-da-integridade-na-administracao-publica-em-mato-grosso/",
  },
  {
    title: "Advocacia, essencial para virtualização da Justiça",
    description: "Reflexões sobre transformação digital da Justiça e o papel institucional da advocacia.",
    image: "/assets/leo-mauricio-oab.jpg",
    href: "/2023/03/02/advocacia-essencial-para-virtualizacao-da-justica-2/",
  },
];

const articleBodies: Record<string, string[]> = {
  "/2023/03/02/termo-anticorrupcao-e-postura-pro-ativa-das-empresas/": [
    "Após o advento da Lei Federal n. 12.846/2013, a chamada Lei Anticorrupção, inaugurou-se uma onda de réplicas legislativas e de regulamentação dos processos administrativos de responsabilização.",
    "Em Mato Grosso foi publicada a Lei Ordinária Estadual de n. 10.744 em 29 de agosto de 2018. De autoria do Deputado Dr. Leonardo, a lei obriga empresas que recebam recursos públicos a assinarem o Termo Anticorrupção.",
    "No fomento incluem-se repasses para organizações sociais, filantrópicas e projetos de estímulo à cultura. Nesse termo, a empresa declara que segue a lei, a moral e os bons costumes.",
    "A nova lei estadual atribuiu forte responsabilidade às empresas recebedoras de recursos públicos, inclusive a obrigação de comunicar problemas ou indícios de irregularidades.",
    "O subscritor do Termo Anticorrupção assume condição de garante. Essa condição atrai a possibilidade de omissão penalmente relevante, conforme dispõe o Código Penal.",
    "A implementação de programas de integridade se mostra duplamente importante: mitiga riscos e atende ao Termo Anticorrupção, dando segurança ao profissional responsável por comunicar irregularidades ao Poder Público.",
    "Maurício Magalhães Faria Neto",
  ],
  "/2023/03/02/o-marco-regulatorio-da-integridade-na-administracao-publica-em-mato-grosso/": [
    "Nos últimos dias tive a grata surpresa de tomar conhecimento de importantíssimo projeto apresentado pelo Deputado Wilson Santos na Assembleia Legislativa do Estado de Mato Grosso.",
    "Em salutar iniciativa, alinhada a outros Estados, o projeto torna obrigatória a apresentação ou implementação de programas de integridade para empresas que contratem com a Administração Pública mato-grossense.",
    "Tal exigência se estenderia também ao Poder Judiciário, Tribunal de Contas, Assembleia Legislativa e Ministério Público Estadual.",
    "Com o fim de avaliar a qualidade do programa de integridade, o projeto elenca requisitos mínimos que devem ser observados e estabelece que contratos em vigência também deverão se adequar.",
    "O texto apresentado tem potencial de transformar a contratação pública, tornando-se marco regulatório e divisor de águas na conduta das empresas contratadas pelo Estado.",
    "Maurício Magalhães Faria Neto",
  ],
  "/2023/03/02/advocacia-essencial-para-virtualizacao-da-justica-2/": [
    "Desde março de 2020, todo o sistema de Justiça do Brasil vem sendo testado em seu limite. Restrições de locomoção e a necessidade de continuidade da prestação jurisdicional aceleraram a virtualização dos atos processuais.",
    "O Tribunal de Justiça de Mato Grosso, ainda em abril de 2020, informou milhares de decisões publicadas em regime de trabalho remoto, e os números nacionais confirmaram a aceleração da Justiça digital.",
    "A digitalização colheu frutos antecipadamente durante a pandemia, promovendo continuidade de boa parte dos trabalhos judiciários.",
    "Contudo, não é possível ignorar a desigualdade digital brasileira. O acesso precário à Internet afeta diretamente o acesso à Justiça e diversos aspectos da vida civil e social.",
    "É neste ponto que reside a preocupação da Ordem dos Advogados do Brasil. A advocacia funciona como porta de entrada do cidadão no sistema de Justiça e como garantia de contraditório, orientação técnica e defesa efetiva.",
    "Videoconferências não substituem integralmente o contato olho a olho de uma sustentação oral, nem capturam todas as sutilezas de audiências de instrução e sessões de mediação.",
    "Todo avanço é salutar para a administração da Justiça, mas não se pode admitir prejuízo às prerrogativas profissionais que concretizam garantias fundamentais.",
    "Leonardo Pio da Silva Campos, Mauricio Magalhães Faria Neto",
  ],
};

function submitByEmail(event: { preventDefault(): void; currentTarget: HTMLFormElement }) {
  event.preventDefault();
  const data = new FormData(event.currentTarget);
  const body = Array.from(data.entries())
    .map(([key, value]) => `${key}: ${value}`)
    .join("\n");
  window.location.href = `mailto:contato@mauriciomagalhaes.adv.br?subject=${encodeURIComponent("Contato pelo site Mauricio Magalhaes")}&body=${encodeURIComponent(body)}`;
}

function Header() {
  return (
    <header className="siteHeader">
      <a className="brand" href="/" aria-label="Mauricio Magalhães Advocacia">
        <img src="/assets/logo.png" alt="Mauricio Magalhães Advocacia" />
      </a>
      <nav aria-label="Navegação principal">
        {navItems.map(([label, href]) => (
          <a key={href} href={href}>{label}</a>
        ))}
      </nav>
    </header>
  );
}

function Footer() {
  return (
    <footer>
      <img src="/assets/logo.png" alt="Mauricio Magalhães Advocacia" />
      <span>Todos os direitos reservados</span>
    </footer>
  );
}

function PageHero({ title }: { title: string }) {
  return (
    <section className="pageHero">
      <h1>{title}</h1>
      <p>Home / {title}</p>
    </section>
  );
}

function OfficePage() {
  return (
    <main>
      <Header />
      <PageHero title="O Escritório" />
      <section className="internalPage officeInternal">
        <div className="textBlock">
          <h2>Sobre nós</h2>
          <p>Fundado em 2008, a sociedade de advogados tem a missão de defender seus clientes prezando pela melhor técnica, zelo, respeito e dedicação.</p>
          <p>Os sócios e demais advogados estão em constante aperfeiçoamento de suas habilidades, com o fim de oferecer soluções sob-medida para as necessidades individuais de cada cliente.</p>
          <p>Buscamos estabelecer laços respeitosos e sólidos com instituições e autoridades constituídas, em especial com o Tribunal de Contas do Estado de Mato Grosso, Tribunal de Justiça do Estado de Mato Grosso e Justiça Eleitoral.</p>
          <p>Perante a advocacia, nossos profissionais estão inseridos nas discussões vanguardistas acerca dos temas mais recentes do direito, compondo diversos quadros de cargos da Ordem dos Advogados do Brasil - Seccional Mato Grosso.</p>
        </div>
        <div className="valuesBlock">
          <h2>Valores</h2>
          <p>Dedicação, lealdade, comprometimento e seriedade são os valores que norteiam nossa atuação profissional. Construímos uma história pautada na correção e no trabalho duro em prol de nossos clientes.</p>
          <div>
            <span>Dedicação total</span>
            <span>Do início ao fim</span>
            <span>Profissionais sempre</span>
          </div>
        </div>
        <div className="imagePair">
          <img src="/assets/hero-03.jpg" alt="Ambiente institucional do escritório" />
          <img src="/assets/hero-04.jpg" alt="Equipe em ambiente jurídico" />
        </div>
        <div className="valueGrid">
          {officePillars.map(([title, description]) => (
            <article className="featureCard" key={title}>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
        <div className="experienceBand">
          <h2>15 Anos de Experiência na Advocacia Empresarial e Eleitoral</h2>
          <strong>Estrutura e capacitação de 1ª Qualidade</strong>
          <h2>Nossas experiências</h2>
          <p>Nossas experiências foram construídas em demandas institucionais, relacionamento com órgãos de controle, atuação empresarial e acompanhamento de temas de direito público.</p>
        </div>
      </section>
      <Footer />
    </main>
  );
}

function AreasPage() {
  return (
    <main>
      <Header />
      <PageHero title="Áreas de Atuação" />
      <section className="internalPage simpleInternal">
        <div className="practiceGrid">
          {practiceAreas.map(([title, description], index) => (
            <article className="practiceCard" key={title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  );
}

function LawyersPage() {
  return (
    <main>
      <Header />
      <PageHero title="Advogados" />
      <section className="internalPage lawyersInternal">
        <h2>Nossa equipe</h2>
        <div className="teamGrid internalTeam">
          {team.map(({ initials, name, registry, description, bio }) => (
            <article className="teamCard" key={name}>
              <span>{initials}</span>
              <h3>{name}</h3>
              <strong>{registry}</strong>
              <p>{description}</p>
              <ul>
                {bio.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  );
}

function ClientsPage() {
  return (
    <main>
      <Header />
      <PageHero title="Clientes" />
      <section className="internalPage clientsOnly">
        <h4>Nossa carteira de clientes satisfeitos</h4>
        <div className="clientGrid">
          {clients.map(([name, image]) => (
            <article className="clientCard" key={name}>
              <img src={image} alt={name} />
              <span>{name}</span>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  );
}

function NewsPage() {
  return (
    <main>
      <Header />
      <PageHero title="Notícias" />
      <section className="internalPage">
        <div className="postsGrid listing">
          {posts.map((post) => (
            <article className="postCard" key={post.href}>
              <img src={post.image} alt={post.title} />
              <div>
                <time>02 março, 2023</time>
                <h3>{post.title}</h3>
                <p>{post.description}</p>
                <a href={post.href}>Leia o artigo</a>
              </div>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  );
}

function ContactPage() {
  return (
    <main>
      <Header />
      <PageHero title="Contato" />
      <section className="internalPage contactInternal">
        <div>
          <h3>Vamos conversar?</h3>
          <p>Para qualquer dúvida jurídica ou demanda, entre em contato. Estamos disponíveis para atendimento das 09h às 17h, nos dias úteis.</p>
          <h3>Esceva sua mensagem abaixo:</h3>
          <form className="contactForm" onSubmit={submitByEmail}>
            <input name="Nome" placeholder="Nome" required />
            <input name="E-mail" type="email" placeholder="E-mail" required />
            <textarea name="Mensagem" placeholder="Mensagem" required />
            <button type="submit">Enviar</button>
          </form>
        </div>
        <aside>
          <h2>Onde estamos:</h2>
          <p>{contactAddress}</p>
          <div className="mapFrame">
            <iframe
              loading="lazy"
              title="Mapa do escritório Mauricio Magalhães"
              src={mapUrl}
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </aside>
      </section>
      <Footer />
    </main>
  );
}

function ArticlePage({ post }: { post: typeof posts[number] }) {
  const body = articleBodies[post.href] || [post.description];
  return (
    <main>
      <Header />
      <article className="articlePage">
        <h1>{post.title}</h1>
        <time>02 março, 2023</time>
        {body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        <section className="commentBlock">
          <h2>Deixe um comentário Cancelar resposta</h2>
          <textarea placeholder="Comentário" />
          <div className="commentFields">
            <input placeholder="Nome" />
            <input placeholder="E-mail" />
            <input placeholder="Site" />
          </div>
          <button type="button">Publicar comentário</button>
        </section>
      </article>
      <Footer />
    </main>
  );
}

function HomePage() {
  return (
    <main>
      <header className="siteHeader">
        <a className="brand" href="/" aria-label="Mauricio Magalhães Advocacia">
          <img src="/assets/logo.png" alt="Mauricio Magalhães Advocacia" />
        </a>
        <nav aria-label="Navegação principal">
          {navItems.map(([label, href]) => (
            <a key={href} href={href}>{label}</a>
          ))}
        </nav>
      </header>

      <section className="heroSection">
        <div className="heroCopy">
          <p className="kicker">Mauricio Magalhães Advocacia</p>
          <h1>Atuação jurídica estratégica para empresas, instituições e agentes públicos.</h1>
          <p className="lead">Soluções técnicas, discrição institucional e segurança jurídica em temas administrativos, regulatórios, empresariais e eleitorais.</p>
          <div className="heroActions">
            <a className="button primary" href="/areas-de-atuacao/">Áreas de atuação</a>
            <a className="button ghost" href="/contato/">Falar com o escritório</a>
          </div>
          <div className="metrics" aria-label="Indicadores do escritório">
            <div><strong>15+</strong><span>anos de experiência</span></div>
            <div><strong>MT</strong><span>atuação com foco institucional</span></div>
            <div><strong>6</strong><span>frentes jurídicas principais</span></div>
          </div>
        </div>
        <div className="heroCards" aria-label="Resumo institucional">
          <article className="featureCard large">
            <span>Credibilidade</span>
            <h2>O escritório</h2>
            <p>Atuação marcada por rigor técnico, zelo profissional e soluções sob medida para demandas complexas.</p>
            <a href="/escritorio/">Ver apresentação</a>
          </article>
          <article className="featureCard"><span>Compliance</span><p>Estrutura e integridade.</p></article>
          <article className="featureCard"><span>Contencioso</span><p>Atuação administrativa e judicial.</p></article>
        </div>
      </section>

      <section className="section">
        <div className="sectionHeader">
          <p className="kicker">Especialidades</p>
          <h2>Áreas de atuação</h2>
          <p>Frentes jurídicas estruturadas para contextos empresariais, administrativos e institucionais.</p>
        </div>
        <div className="practiceGrid">
          {practiceAreas.map(([title, description]) => (
            <article className="practiceCard" key={title}>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section officeBand">
        <div className="officeIntro">
          <p className="kicker">Institucional</p>
          <h2>O escritório</h2>
          <p>Fundado em 2008, o escritório atua com a missão de defender os interesses de seus clientes com técnica, respeito, dedicação e visão estratégica. A equipe mantém formação contínua para oferecer soluções sob medida, seguras e consistentes.</p>
          <p>Também busca relações institucionais sólidas com órgãos de controle, Justiça Eleitoral, Justiça Estadual e demais autoridades constituídas.</p>
          <a href="/escritorio/">Ler a apresentação completa</a>
        </div>
        <div className="pillarList">
          {officePillars.map(([title, description]) => (
            <article className="featureCard" key={title}>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="sectionHeader">
          <p className="kicker">Equipe</p>
          <h2>Nossa equipe</h2>
          <p>Profissionais com formação qualificada, atuação técnica e experiência em demandas institucionais e empresariais.</p>
        </div>
        <div className="teamGrid">
          {team.map(({ initials, name, registry, description }) => (
            <article className="teamCard" key={name}>
              <span>{initials}</span>
              <h3>{name}</h3>
              <strong>{registry}</strong>
              <p>{description}</p>
            </article>
          ))}
        </div>
        <div className="centerAction">
          <a className="button ghost" href="/advogados/">Conheça a equipe completa</a>
        </div>
      </section>

      <section className="section clientsSection">
        <div className="sectionHeader">
          <p className="kicker">Relacionamento institucional</p>
          <h2>Clientes</h2>
          <p>Empresas de diferentes setores atendidas com discrição, solidez técnica e compromisso institucional.</p>
        </div>
        <div className="clientGrid">
          {clients.map(([name, image]) => (
            <article className="clientCard" key={name}>
              <img src={image} alt={name} />
              <span>{name}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="sectionHeader">
          <p className="kicker">Conteúdo</p>
          <h2>Notícias e análises</h2>
          <p>Publicações sobre integridade, administração pública, advocacia institucional e temas jurídicos relevantes.</p>
        </div>
        <div className="postsGrid">
          {posts.map((post) => (
            <article className={post.large ? "postCard large" : "postCard"} key={post.title}>
              <img src={post.image} alt={post.title} />
              <div>
                <time>02 março, 2023</time>
                <h3>{post.title}</h3>
                <p>{post.description}</p>
                <a href={post.href}>Leia o artigo</a>
              </div>
            </article>
          ))}
        </div>
        <div className="centerAction">
          <a className="button ghost" href="/noticias/">Ver todas as notícias</a>
        </div>
      </section>

      <section className="section contactBand">
        <div>
          <p className="kicker">Contato</p>
          <h2>Vamos conversar?</h2>
          <p>Para dúvidas jurídicas e demandas institucionais, entre em contato com o escritório. O atendimento é realizado com discrição, clareza e objetividade.</p>
          <ul>
            <li><strong>Telefone:</strong> (65) 3044-9922</li>
            <li><strong>E-mail:</strong> contato@mauriciomagalhaes.adv.br</li>
            <li><strong>Horário:</strong> dias úteis, das 09h às 17h</li>
            <li><strong>Endereço:</strong> {contactAddress}</li>
          </ul>
        </div>
        <aside className="contactCard">
          <span>Atendimento institucional</span>
          <h3>Canal direto com o escritório</h3>
          <p>Utilize a página de contato para enviar sua mensagem com mais detalhes e direcionar corretamente a sua demanda.</p>
          <a className="button primary" href="/contato/">Enviar contato</a>
          <small>Retornaremos com a seriedade compatível com a natureza da sua solicitação.</small>
        </aside>
      </section>

      <footer>
        <img src="/assets/logo.png" alt="Mauricio Magalhães Advocacia" />
        <span>Todos os direitos reservados</span>
      </footer>
    </main>
  );
}

function App() {
  const path = window.location.pathname;
  const post = posts.find((item) => item.href === path);

  if (post) return <ArticlePage post={post} />;
  if (path.startsWith("/escritorio")) return <OfficePage />;
  if (path.startsWith("/areas-de-atuacao")) return <AreasPage />;
  if (path.startsWith("/advogados")) return <LawyersPage />;
  if (path.startsWith("/clientes")) return <ClientsPage />;
  if (path.startsWith("/noticias")) return <NewsPage />;
  if (path.startsWith("/contato")) return <ContactPage />;

  return <HomePage />;
}

export default App;
